import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import type * as React from "react";

import { cn } from "../utils";
import { Icon } from "./icon";

// NOTE: Every time the checked value changes, the `CheckboxBubbleInput` is emitting a `click` event.
// See: https://github.com/radix-ui/primitives/blob/36d954d3c1b41c96b1d2e875b93fc9362c8c09e6/packages/react/checkbox/src/checkbox.tsx#L337

function Checkbox({ className, ...props }: React.ComponentProps<typeof CheckboxPrimitive.Root>) {
  return (
    <CheckboxPrimitive.Root
      className={cn(
        `
          peer size-[calc(1em_+_4px)] inline-flex items-center justify-center shrink-0 rounded-sm border border-input bg-background
          ring-offset-background focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2
          disabled:cursor-not-allowed disabled:opacity-50
          data-[state=checked]:bg-primary data-[state=checked]:border-primary data-[state=checked]:text-primary-foreground
          data-[state=indeterminate]:bg-transparent data-[state=indeterminate]:border-primary data-[state=indeterminate]:text-primary
        `,
        className
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        className={cn("flex text-[calc(1em_+_3px)] items-center justify-center text-current")}
      >
        {props.checked === "indeterminate" && <Icon icon="remove" />}
        {props.checked === true && <Icon icon="check" style={{ fontVariationSettings: `"wght" 700` }} />}
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
}

export { Checkbox };
